import {Module} from 'vuex'
import {RootState} from '@/store/types'
import {MediaObject, MediaUpload, QueueState} from '@/modules/media/types'
import actions from '@/modules/media/store/actions'
import mutations from '@/modules/media/store/mutations'
import getters from '@/modules/media/store/getters'


export interface MediaState {
    objects: MediaObject[]
    showUploadManager: boolean
    currentMedia: MediaObject
    hasSelectedMedia: boolean,
    hasSelectedUpload: boolean,
    selectedObjects: number[],
    deletingSelection: boolean
    showDeleteConfirmModal: boolean

    // Estado para el administrador de subidas
    uploadQueue: MediaUpload[]
    currentUpload: string
    /**
     * Indica el estado actual de la cola de ficheros que serán subidos al
     * servidor.
     */
    queueState: QueueState,

    /**
     * Declara una lista con los tipos MIME de archivos válidos para subir al servidor.
     * Si el usuario intenta añadir a la cola de subida un archivo cuyo tipo mime no
     * se encuentra en esta lista lista la aplicación impedirá que sea añadido y
     * notificará al usuario.
     */
    validFileTypes: string[]

    /**
     * Tamaño máximo
     *
     * Indica en bytes el tamaño máximo de los ficheros que son subidos al servidor.
     * Si algún fichero sobrepasa el límite, el administrador de subidas impedirá
     * que el archivo sea añadido a la cola de subida y se notificará al
     * usuario
     */
    maxFileSize: number

    /**
     * Indica si la aplicación ya ha obtenido los límites de subida
     *
     * @var { boolean }
     */
    uploadConstrainsFetched: boolean,

    /**
     * Tamaños de miniaturas
     */
    thumbnailSizes: {[key: string]: number},
}

const vuexModule: Module<MediaState, RootState> = {
    namespaced: true,
    mutations,
    actions,
    getters,
    state: {
        objects: [],
        uploadQueue: [],
        currentUpload: '',
        showUploadManager: false,
        currentMedia: new MediaObject(),
        hasSelectedMedia: false,
        hasSelectedUpload: false,
        selectedObjects: [],
        deletingSelection: false,
        showDeleteConfirmModal: false,
        maxFileSize: 0,
        uploadConstrainsFetched: false,
        validFileTypes: [
            'image/png', 'image/jpeg',
        ],
        queueState: QueueState.Open,
        thumbnailSizes: {},
    },
}

export default vuexModule
